import { useAccount, State } from '@grandvisionhq/auth';
import { useFeatureToggles } from '@grandvisionhq/state';

const useWishlistAuthState = ()=>{
    const authState = useAccount();
    const { isMyAccountEnabled  } = useFeatureToggles();
    const isAuthLoading = isMyAccountEnabled && authState === 'UNKNOWN';
    const isUserLoggedIn = isMyAccountEnabled && authState === State.AuthState.LoggedIn;
    return {
        isAuthLoading,
        isUserLoggedIn
    };
};

export { useWishlistAuthState };
//# sourceMappingURL=use-wishlist-auth-state.js.map
